import { render, staticRenderFns } from "./send-invoice-dialog.vue?vue&type=template&id=854f408a&scoped=true&"
import script from "./send-invoice-dialog.vue?vue&type=script&lang=js&"
export * from "./send-invoice-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-invoice-dialog.vue?vue&type=style&index=0&id=854f408a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854f408a",
  null
  
)

export default component.exports